export default "__VITE_ASSET__Dcn5pjw___"